function Button(props) {
  return (
    <div style={props.style} className={`form-button ${props.btnType}`} onClick={props.onClick}>
      <button>{props.name}</button>
      {props.icon && <img src={props.icon} alt={props.name} />}
    </div>
  );
}

export default Button;
